import { Component } from '@angular/core';
//import {HomePage } from '../home/home'
import { AppState } from '../../../app/app.global';
import { NavController,App,NavParams,AlertController} from 'ionic-angular';
import { HomePage } from '../home/home';
import { DragulaService } from 'ng2-dragula/ng2-dragula';
import { StorageService } from '../../../providers/service/storageservice';
import { HttpService } from '../../../providers/service/httpservice';

@Component({
  selector: 'homeset-page',
  templateUrl: 'homeset.html'
})
export class HomeSetPage {
	// rotationCheck:boolean;
	// popularCheck:boolean;
	// applyCheck:boolean;
	// checkStatus:any;
	user:any={};
	public list = [];
	public firstList = [];
	public homeList = [];
	callback;
	constructor(public navCtrl: NavController,public global: AppState,private httpService:HttpService,
				public appCtrl: App,public navParams: NavParams,
				public dragulaService: DragulaService,public alertCtrl: AlertController) {
					this.user = StorageService.getObj('currentUser');
					console.dir(localStorage.getItem('homeSet'));
					 this.list = this.navParams.get("list");
					this.firstList = this.navParams.get("firstList");
					for(let i=0;i<this.list.length;i++){
						this.homeList.push({name: this.list[i].name, code: this.list[i].code, status: this.list[i].status});
						
					}
				
			
		
		this.callback = this.navParams.get("callback");
	}


//增加栏目
	changeData(key ,status){
		this.homeList[key].status=status;   /*改变数组的数据*/
	}

	saveHomeset(){
		var divs =document.getElementsByClassName("dragulaSortClass");
		const dragulaSort = [];
		for(var i=0;i<divs.length;i++){
			// 获取集合单个元素的id值
			if( divs[i].innerHTML != undefined && divs[i].innerHTML != null && divs[i].innerHTML != ""){
			  // 排序参数
			  for (let index = 0; index < this.homeList.length; index++) {
				  const element = this.homeList[index].name;
				  if(element == divs[i].innerHTML){
					dragulaSort.push(this.homeList[index]);
				  }
			  }
			}
		}
		console.dir(dragulaSort);
		//   this.list = dragulaSort;
		this.list = this.homeList;
		localStorage.setItem('homeSet',JSON.stringify(dragulaSort));
		// localStorage.setItem('homeSet',JSON.stringify(this.list));
		//返回首页
		let param = 'homeSet' 
		this.callback(param).then(()=>{
			this.navCtrl.pop();
		});
	}

	ionViewWillLeave(){
		console.log("homeList=" + this.homeList);
		console.log("list=" + this.list);
	}

}



// WEBPACK FOOTER //
// ./src/pages/home/homeset/homeset.ts